import { Ability } from "@casl/ability";

const baseRoutes = [{ action: "read", subject: "Home" }];
export const ability = new Ability(baseRoutes);
